<template>
  <span @click="clear">
    <slot name="trigger" :processing="command.processing"></slot>
  </span>
</template>

<script>
export default {
  props: ["tags"],

  data() {
    return {
      command: new window.Form()
    };
  },

  methods: {
    clear() {
      if (this.command.processing) {
        return false;
      }

      this.command
        .takeAtLeast(300)
        .delete("/admin/api/tools/cache?tags=" + this.tags)
        .then(() => this.$buefy.toast.open("Cache цэвэрлэгдсэн."));

      if (this.tags.includes("home")) {
        this.command.takeAtLeast(300).delete("/api/mobile-app/cache/clear");
      }
    }
  }
};
</script>
